import actions from "redux-form/lib/actions";
import * as actionTypes from "../../Constants/clients/clientActionTypes";

const initialState = {
    edited: false,
    rowsCount: 0,
    showLoader: false,
    isClearFilters: false,
    clients: [],
    clientTypes: [],
    suffix: [],
    locations: [],
    groupNames: [],
    primaryTaskTypes: [],
    selectedClients: {
        selectedClientsIds: []
    },
    isAddNewClient: false,
    originalAllClients: "",
    clientDataById: {},
    firmSettings: {},
    staffDetails: {},
    searchUserDetails: {}
}


const allClients = (state = initialState, action) => {

    switch (action.type) {
        case actionTypes.FETCH_ALL_CLIENTS:
            return {
                ...state,
                clients: action.payload.clients,
                originalAllClients: JSON.stringify(action.payload.clients),
                selectedClients: {
                    ...state.selectedClients,
                    selectedClientsIds: []
                },
                showInfoBanner: action.payload.showInfoBanner,
                rowsCount: action.payload.clients.length
            }
        case actionTypes.FETCH_CLIENT_TYPES:
            return {
                ...state,
                clientTypes: action.payload.clientTypes.clientType,
            }
        case actionTypes.FETCH_GENERATION_TYPES:
            return {
                ...state,
                suffix: action.payload.generationTypes.firmGenerationType,
            }
        case actionTypes.FETCH_LOCATIONS:
            return {
                ...state,
                locations: action.payload.locations.firmBranch,
            }

        case actionTypes.FETCH_TASK_TYPES:
            return {
                ...state,
                primaryTaskTypes: action.payload.primaryTaskTypes.taskType,

            }
        case actionTypes.FETCH_GROUPS:
            return {
                ...state,
                groupNames: action.payload.clientGroups.clientGroups,

            }

        case actionTypes.CLEAR_ALL_FILTERS:
            return {
                ...state,
                isClearFilters: action.payload.isClearFilters,
                clients: action.payload.allClients,
                selectedClients: {
                    ...state.selectedClients,
                    selectedClientsIds: [],
                }
            };
        case actionTypes.ROWS_COUNT_AFTER_FILTER:
            return {
                ...state,
                rowsCount: action.payload.rowsCount
            };
        case actionTypes.SHOW_LOADER:
            return {
                ...state,
                showLoader: action.payload.showLoader,
                loaderMessage: action.payload.loaderMessage
            }
        case actionTypes.IS_EDITED:
            return {
                ...state,
                edited: action.payload.edited,
            }
        case actionTypes.SAVE_EDITS:
            return {
                ...state,
                clients: action.payload.clientData,
                edited: false,
            }
        case actionTypes.DISCARD_CHANGES_CLIENT: {
            let originClients;
            try {
                originClients = JSON.parse(state.originalAllClients);
            }
            catch (error) {
                console.error('Invalid JSON input:', error.message);
            }
            return {
                ...state,
                edited: false,
                mychangedRows: [],
                clients: originClients
            }
        }
        case actionTypes.GET_SELECTED_CLIENTS:

            return {
                ...state,
                selectedClients: action.payload
            };
        case actionTypes.ADD_NEW_CLIENT:
            return {
                ...state,
                isAddNewClient: action.payload.isAddNewClient
            };
        case actionTypes.GET_CLIENTS_BY_ID:
            return {
                ...state,
                clientDataById: action.payload.clientDataById
            };
        case actionTypes.GET_FIRM_SETTINGS:
            return {
                ...state,
                firmSettings: action.payload.firmSettings.firmSettings,
            };
        case actionTypes.STAFF_ASSIGNMENT_LOOK_UP:
            return {
                ...state,
                staffDetails: action.payload.staffAssignmentDetails,
            };
        case actionTypes.SEARCH_USER_LOOK_UP:
            return {
                ...state,
                searchUserDetails: action.payload.searchStaffDetails,
            };
        case actionTypes.UPDATE_DEFAULT_CLIENTS:
            return {
                ...state,
                originalAllClients: JSON.stringify(action.payload.clients),
            };
        default:
            return state
    }
}

export default allClients

